// extracted by mini-css-extract-plugin
module.exports = {"Forms":"Homepage_Forms__12Tmz"};